import { mediaAsset } from '../config/media';

export const projects = [
  {
    id: 'lullabai',
    title: 'Lullabai',
    path: '/work/lullabai',
    type: 'Co-founder · Generative music · iOS',
    period: '2020–Present',
    summary: 'An original-data generative-music system and iOS app built for sleep, rest, and focus.',
    role: 'Co-founder, Product Designer, Audio Systems Designer, and Mobile Engineer',
    highlights: [
      'Founded and launched the product through release on the U.S. App Store.',
      'Designed and developed the consumer iOS experience.',
      'Created an original composition dataset and data-collection methodology for the generative system.',
      'Built sound-design, music-production, and audio-content pipelines spanning multiple musical styles.',
    ],
    media: {
      card: 'Lullabai application overview',
      cardImage: mediaAsset('images/lullabai/lullabai-app-icon.png'),
      cardImageAlt: 'Lullabai app icon',
      hero: 'Lullabai channel-player interface',
      process: 'Generative music pipeline diagram',
      detail: 'Mobile playback and channel-list screens',
    },
    status: 'published',
  },
  {
    id: 'remote-studio',
    title: 'Remoto',
    path: '/work/remote-studio',
    type: 'Product engineering leadership · Real-time media',
    period: '2020–Present',
    summary: 'Built and owned six web, iOS, and Apple TV applications for a real-time post-production collaboration platform.',
    role: 'Head of Web & Mobile Product Engineering',
    highlights: [
      'Progressed from DAW-integration consultant and project manager to leading product engineering across six applications.',
      'Delivered 46 major product features from July 2025 through July 2026.',
      'Built an AI-powered, computer-vision UI automation harness covering 79 onboarding scenarios across three applications.',
      'Reduced regression testing from approximately 70 hours to 30 minutes per release.',
      'Translate customer needs into requirements, prototypes, technical specifications, roadmaps, and release plans.',
    ],
    media: {
      card: 'Remoto product overview',
      cardImage: mediaAsset('images/remote-studio/remoto-system-logo.svg'),
      cardImageAlt: 'Remoto',
      hero: 'Remote audio session interface',
      process: 'Remote post-production workflow diagram',
      detail: 'Session controls and participant roles',
    },
    status: 'published',
  },
  {
    id: 'mf-1',
    title: 'MF-1',
    path: '/work/mf-1',
    type: 'Hardware · MIDI · Full-stack prototyping',
    period: '2019',
    summary: 'A compact motorized MIDI fader controller designed for music production and mixing.',
    role: 'Designer and Engineer',
    highlights: [
      'Combined embedded systems, electronics, interface design, and instrument fabrication.',
      'Explored responsive physical control with a lower cost, weight, and footprint than commercial alternatives.',
      'Developed the controller as an end-to-end hardware and software prototype.',
    ],
    media: {
      card: 'MF-1 motorized-fader prototype',
      cardImage: mediaAsset('images/mf-1/mf-1-card-cover.jpeg'),
      cardImageAlt: 'Close-up of the MF-1 motorized faders and internal electronics',
      hero: 'MF-1 hardware hero photograph',
      process: 'PCB and enclosure development',
      detail: 'Fader controls and prototype details',
    },
    status: 'published',
  },
];

export const projectsById = Object.fromEntries(
  projects.map((project) => [project.id, project])
);
